import { getContext, setContext } from 'svelte';

export interface LayerContext {
    layer: number;
}

export class LayerService {
    public getLayer(key: string): number {
        const searchContext = getContext<(() => LayerContext | undefined) | undefined>(key);
        if (!searchContext) {
            return 0;
        }

        return Math.max(0, searchContext()?.layer ?? -1);
    }

    public setLayer(key: string, layer: number): void {
        const writeContext: LayerContext = {
            layer: Math.max(0, Math.round(layer)),
        };

        setContext(key, () => writeContext);
    }

    public getContentLayer(): number {
        return this.getLayer('content-layer');
    }

    public setContentLayer(layer: number): void {
        this.setLayer('content-layer', layer);
    }

    public upContentLay(): number {
        const NextContentLayer = this.getContentLayer() + 1;
        this.setContentLayer(NextContentLayer);
        return NextContentLayer;
    }

    public getNavigationLayer(): number {
        return this.getLayer('navigation-layer');
    }

    public setNavigationLayer(layer: number): void {
        this.setLayer('navigation-layer', layer);
    }

    public upNavigationLayer(): number {
        const NextNavigationLayer = this.getNavigationLayer() + 1;
        this.setNavigationLayer(NextNavigationLayer);
        return NextNavigationLayer;
    }
}
